import React from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources } from '@erecruit/types';

const { FormattedMessage } = Intl;

export default ({ data }: { data: Resources.MatchPeople }) => {
  const {
    candidateOwner,
    primaryPositionOwner,
    vendor,
    payrollContact,
    accountingContact,
  } = data;

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage id={messageIds.vms.matchRecord.people.title} />
          </H3>
        }
      >
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.people.candidateOwner}
            />
          }
          type={CardInfoValueType.Text}
          value={candidateOwner?.name}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.people.positionOwner}
            />
          }
          type={CardInfoValueType.Text}
          value={primaryPositionOwner?.name}
        />
        <CardInfoItem
          label={
            <FormattedMessage id={messageIds.vms.matchRecord.people.vendor} />
          }
          type={CardInfoValueType.Text}
          value={vendor?.name}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.people.payrollContact}
            />
          }
          type={CardInfoValueType.Text}
          value={payrollContact?.name}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.people.accountingContact}
            />
          }
          type={CardInfoValueType.Text}
          value={accountingContact?.name}
        />
      </CardInfo>
    </FlexItem>
  );
};
